<div class="layout-sidebar" [ngStyle]="{'overflow':appComponente.sidebarActive ? 'hidden' : 'visible'}"
     [ngClass]="{'layout-sidebar-dark':appComponente.darkMenu}" (click)="appComponente.onSidebarClick($event)">
  <div class="layout-tabmenu" *ngIf="cargando">
    <ul class="layout-tabmenu-nav">
      <li>
        <i class="fa fa-refresh fa-spin fa-fw"></i>
      </li>
    </ul>
  </div>
  <div class="layout-tabmenu" *ngIf="!cargando">
    <img src="assets/images/icono-analizamos-blanco.svg"
    style="width: 45px;
    height: 45px;
    margin: 0px 10px;
    margin-top: 20px;
    margin-bottom: 10px;" alt=""/>
    <ul class="layout-tabmenu-nav">
      <li [ngClass]="{'active-item':appComponente.activeTabIndex === i}" *ngFor="let item of menu, let i = index">
        <a class="ripplelink tabmenuitem-link" (click)="appComponente.onTabClick($event, i)"
          style="align-items: center;align-content: center;text-align: center;display: flex;">
          <img style="height: 40px;width: 40px;margin-left: auto; margin-right: auto;"
               [src]="(item.adjunto && item.adjunto.adjuntoBase64) ? sanitizer.bypassSecurityTrustResourceUrl(item.adjunto.adjuntoBase64) : 'assets/images/icono-perfil-usuario.svg'" alt="">
        </a>
        <div class="layout-tabmenu-tooltip">
          <div class="layout-tabmenu-tooltip-arrow"></div>
          <div class="layout-tabmenu-tooltip-text">{{item.menu}}</div>
        </div>
      </li>
    </ul>
    <div class="layout-tabmenu-contents">
      <div class="layout-tabmenu-content" *ngFor="let item of menu, let i = index"
           [ngClass]="{'layout-tabmenu-content-active': appComponente.activeTabIndex === i}">
        <div class="layout-submenu-title clearfix">
          <span>{{item.menu | uppercase}}</span>
        </div>
        <div class="menu-buscar">
          <input type="text" class="input-menu-buscar" placeholder="buscar..." (keyup)="llamarBuscarMenu()">
        </div>
        <app-barra-lateral-contenido *ngIf="item.hijos.length>0">
          <app-barra-lateral-menu [menu]="item"></app-barra-lateral-menu>
        </app-barra-lateral-contenido>
      </div>
    </div>
  </div>
</div>
